/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AuthSupportSyncList } from '../../models/auth-support-sync-list';

export interface GetAuthSupportSyncVnf$Params {
}

export function getAuthSupportSyncVnf(http: HttpClient, rootUrl: string, params?: GetAuthSupportSyncVnf$Params, context?: HttpContext): Observable<StrictHttpResponse<AuthSupportSyncList>> {
  const rb = new RequestBuilder(rootUrl, getAuthSupportSyncVnf.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AuthSupportSyncList>;
    })
  );
}

getAuthSupportSyncVnf.PATH = '/custom/auth-supports/sync';
